import moment from 'moment'
import React, { useEffect, useState } from 'react'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Edit from '@material-ui/icons/Edit';
import { Avatar } from '@mui/material';
import { connect } from 'react-redux'
import fbConfig from '../../config/fbConfig'
import { Label, Button, Loader, Radio, Form, Input } from 'semantic-ui-react'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Share from '@mui/icons-material/Share';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { getAllAds, getDataPreferencesFromUser, getDataProfile, updatePreferencesOfUser } from '../../redux/actions/user'
import './Profile.scss'
import userImageProfile from '../../assets/user.svg'
import { toast } from 'react-toastify';
import { setNullUid, signOut } from '../../redux/actions/auth';
import { getUserProvider } from '../../helpers';
import { getAdsShield, getUserPreferencesAdsDB, logout } from '../../functions';

const Profile = props => {

    const { ads, dataUser } = props;

    const [dataPrefs, setDataPrefs] = useState(null);
    const [otherPrefs, setOtherPrefs] = useState(null)

    const [values, setValues] = useState(dataPrefs ? dataPrefs : {})
    const [birthday, setBirthday] = useState(dataPrefs ? dataPrefs.birthday : null)
    const [phone, setPhone] = useState(dataPrefs ? dataPrefs.phone : null)
    const [genre, setGenre] = useState(dataPrefs ? dataPrefs.genre : null)
    const [profession, setProfession] = useState(dataPrefs ? dataPrefs.profession : null)
    const [adblocker, setAdblocker] = useState(dataPrefs && dataPrefs.adblocker === true ? 'Si'
    : dataPrefs && dataPrefs.adblocker === false ? 'No' : null)
    const [checkPref, setCheckPref] = useState( [] )
    const [prefDefault, setPrefDefault] = useState([])
    const [active, setActive] = useState( dataPrefs && dataPrefs.income ? dataPrefs.income : '35')
    const [more, setMore] = useState(false)
    const [loading, setLoading] = useState(false)
    const [imageProfile, setImageProfile] = useState(dataUser ? dataUser.image_profile : userImageProfile)

    const [userProvider, setUserPovider] = useState(null)

    useEffect(() => {

        fbConfig.auth().onAuthStateChanged(user => {
            if(!user) {
                props.setNullUid()
                props.history.push('/signin')
            }
        })

        getProvider()
        getAdsUser()

        if(dataUser) {
            setImageProfile(dataUser.image_profile || userImageProfile)
            setValues({
                ...values,
                email: dataUser.email,
                image_profile: dataUser.image_profile || userImageProfile
            })
        } else {
            props.getDataProfile()
        }

        if(loading === true) {
            toast.info('Actualizando...', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }

    }, [loading])


    const getAdsUser = async () => {
        
        const response = await getUserPreferencesAdsDB();
        const responseAds = await getAdsShield()

        if(response && response.result) {
            setDataPrefs(response.result)
            console.log(response.result)

            setBirthday(response.result.birthday)
            setPhone(response.result.phone)
            setGenre(response.result.genre)
            setProfession(response.result.profession)
            setActive(response.result.income)
            setAdblocker(response.result.adblocker === true ? 'Si'
            : response.result && response.result.adblocker === false && 'No')
            
            setValues({
                ...response.result
            })

            if(checkPref.length === 0) {
                let arrayPrefs = response.result.ads.map(dp => {
                    return dp.id
                })
                setCheckPref([...arrayPrefs])
                setPrefDefault([...arrayPrefs])
            }

            if(responseAds && responseAds.result) {
                console.log(response.result.ads, responseAds.result)
                const otherPref = responseAds.result.filter(ad => {
                    let find = response.result.ads.find(dt => dt.id === ad.id )
                    
                    return !find && ad;
                })
    
                console.log(otherPref)
                setOtherPrefs(otherPref)
            }
        }

    }

    // Funcion para obtener el proveedor del usuario
    const getProvider = async () => {
        const response = await getUserProvider();
        setUserPovider(response[0].providerId)
    }

    // Cerrar sesion
    const signOutSession = async () => {
        await logout()
    }

    const handleOnChange = (e, { value }) => {
        setGenre(value)
        setValues({
            ...values,
            genre: value
        })
    }

    const handleOnChangeImage = ev => {

        setImageProfile(ev.target.files[0]);
        setValues({
            ...values,
            image_profile: ev.target.files[0]
        })
    }

    const handleOnChangeProfession = (e, { value }) => {
        setProfession(value)
        setValues({
            ...values,
            profession: value
        })
    }


    const handleOnChangeAdBlocker = (e, { value }) => {
        setAdblocker(value)
        setValues({
            ...values,
            adblocker: value === 'Si' ? true : false
        })
    }


    const handleOnChangeBirthday = e => {

        const {name, value} = e.target;
        setValues({
            ...values,
            [name]: value
        })

    }

    const addAds = id => {

        let arrayCheck = checkPref;

        if(!arrayCheck.includes(id)) {
            arrayCheck.push(id);
        }
        
        setCheckPref([...arrayCheck])
        setValues({
            ...values,
            type_ads: [...arrayCheck]
        })

    }

    const handleOnChangeData = e => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        }) 
    }

    const removeAdd = id => {

        let newArrayCheck = checkPref.filter(cp => cp !== id);
        
        setCheckPref([...newArrayCheck])
        setValues({
            ...values,
            type_ads: [...newArrayCheck]
        })

    }

    // Funcion para guardar las preferencias
    const handleOnSubmit = async () => {
        
        console.log(values);
        setLoading(true)
        console.log(userProvider)
        const response = await updatePreferencesOfUser({...values, income: active, prefDefault, provider: userProvider});
        setLoading(false)
        if(response && response.status === true) {
            toast.success('Tu nueva información ha sido guardada con éxito', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
        if(response && response.error) {

            if(response.error.code === 'auth/requires-recent-login') {
                toast.error('Por motivos de seguridad, debes iniciar sesión de nuevo para llevar a cabo esta operación', {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            } else {
                toast.error('Ha ocurrido un error al actualizar tus preferencias, por favor inténtelo de nuevo', {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            }
            
        }
        
    }

    // Funcion para copiar el texto
    const copyText = async () => {

        const content = document.getElementById('linkShield');

        await navigator.clipboard.writeText(content.textContent);
        
        toast.success('Enlace copiado correctamente', {
            position: "top-center",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }

    return (
        <div className='profile'>
            
            <div className='profile_content'>
                <div className='profile_content_header'>
                    <Label style={{ marginBottom: '40px' }}>DATOS DE LA CUENTA</Label>
                    <div style={{ display: 'flex' }}>
                        <Button className='btn_logout' onClick={signOutSession}>
                            <PowerSettingsNewIcon fontSize='small' style={{ marginRight: '5px', color: 'white' }} />
                            Cerrar sesión
                        </Button>
                        <span style={{ fontSize: '16px', color: 'grey', marginTop: '5px', display: 'none' }} id='linkShield'>
                            https://shield-staged.web.app
                        </span>
                        <Button className='btn_logout' onClick={copyText}>
                            
                            <Share fontSize='small' style={{ marginRight: '5px', color: 'white' }} />
                            Invitar a un amigo
                        </Button>
                    </div>
                </div>
                <div className='profile_content_data'>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <Avatar
                            src={imageProfile && imageProfile.name ? 
                                URL.createObjectURL(imageProfile) : 
                                imageProfile} 
                            sx={{ width: 160, height: 160 }} />
                        <Button as='label' htmlFor='id_image' type='button'>
                            <Edit fontSize='small' style={{ marginRight: '5px', color: 'white' }} />
                            Cambiar imagen de perfil
                        </Button>
                        <input type='file' hidden id='id_image' onChange={handleOnChangeImage} />
                    </div>
                    <Form>
                        {userProvider === 'password' ? <Form.Field>
                            <label>Email</label>
                            <Input placeholder='Email' name='email' type='text' value={values.email} onChange={handleOnChangeData} />
                        </Form.Field> : null}
                        {userProvider === 'password' ? <Form.Field>
                            <label>Password</label>
                            <Input placeholder='Password' name='password' type='password' onChange={handleOnChangeData} />
                        </Form.Field> : null}
                        <Form.Field>
                            <label>Phone</label>
                            <Input placeholder='Phone' name='phone' type='text' value={values.phone} onChange={handleOnChangeData} />
                        </Form.Field>
                    </Form>
                </div>
                <Label>DATOS PERSONALES</Label>
                <div className='selectors'>
                    <div>
                        <span>Fecha de Nacimiento</span>
                        <div className='input'>
                            <input 
                                placeholder='Año'
                                icon='long arrow alternate down' 
                                type='text' 
                                data-date-format="YYYY-MM-DD"
                                name='birthday'
                                value={ values.birthday && values.birthday.seconds  ? 
                                    moment(new Date(values.birthday.seconds) * 1000).format("L") : 
                                    values.birthday }
                                onChange={handleOnChangeBirthday}
                                onFocus={ e => e.currentTarget.type = 'date' }
                                onBlur={ e => e.currentTarget.type = 'text' } />
                        </div>
                    </div>

                    <div>

                        <span>Género</span>
                        <div style={{ display: 'flex' }}>
                            <Radio 
                                radio
                                label='Masculino'
                                name='genre'
                                value='Masculino'
                                checked={ genre === 'Masculino' }
                                onChange={handleOnChange} />
                            <Radio 
                                radio
                                label='Femenino'
                                name='genre'
                                value='Femenino'
                                checked={ genre === 'Femenino' }
                                onChange={handleOnChange} />
                        </div>
                    </div>

                    <div>

                        <span>Profesión</span>
                        <div style={{ display: 'flex' }}>
                            <Radio 
                                radio
                                label='Estudiante'
                                name='profession'
                                value='Estudiante'
                                checked={ profession === 'Estudiante' }
                                onChange={handleOnChangeProfession} />
                            <Radio 
                                radio
                                label='Empleado'
                                name='profession'
                                value='Empleado'
                                checked={ profession === 'Empleado' }
                                onChange={handleOnChangeProfession} />
                            <Radio 
                                radio
                                label='Desempleado'
                                name='profession'
                                value='Desempleado'
                                checked={ profession === 'Desempleado' }
                                onChange={handleOnChangeProfession} />
                        </div>
                    </div>
                </div>
                <div className='selectors'>
                    <div className='selectors_income'>
                        <span>Tus ingresos</span>
                        <div style={{ display: 'flex' }}>
                            <Button 
                                className={active === '0' ? 'active' : 'inactive'}
                                onClick={() => setActive('0')}>
                                0 - 29k
                            </Button>
                            <Button 
                                className={active === '35' ? 'active' : 'inactive'}
                                onClick={() => setActive('35')}>
                                30 - 45k
                            </Button>
                            <Button 
                                className={active === '45' ? 'active' : 'inactive'}
                                onClick={() => setActive('45')}>
                                45 - 56k
                            </Button>
                            <Button 
                                className={active === '60' ? 'active' : 'inactive'}
                                onClick={() => setActive('60')}>
                                60k +
                            </Button>
                        </div>
                    </div>

                    <div style={{ width: '45%' }}>
                        <span>¿Has usado un AdBlocker anteriormente?</span>
                        <div style={{ display: 'flex', marginTop: '10px' }}>
                            <Radio 
                                radio
                                label='Si'
                                name='adblocker'
                                value='Si'
                                checked={ adblocker === 'Si' }
                                onChange={handleOnChangeAdBlocker} />
                            <Radio 
                                radio
                                label='No'
                                name='adblocker'
                                value='No'
                                checked={ adblocker === 'No' }
                                onChange={handleOnChangeAdBlocker} />
                        </div>
                    </div>
                </div>
                <Label>PREFERENCIAS</Label>
                <div className='publicity'>
                    {
                        dataPrefs && dataPrefs.ads.length > 0 ?
                        dataPrefs.ads.map( (item, index) => (

                            <div key={index} className='publicity_item'>
                                <div className='publicity_item_bottom' style={{ backgroundImage: `url(${item.image_url})` }}/>
                                <span>
                                    {item.name.toUpperCase()}
                                </span>
                                <div className='publicity_item_tags'>
                                    {
                                        item.subgenres.map((sb, index) => (
                                            <p key={index}>{sb}</p>
                                        ))
                                    }
                                </div>
                                <div className='publicity_item_check'>
                                    {
                                        checkPref.includes(item.id.toString()) ?
                                        <CheckCircleIcon  onClick={() => removeAdd(item.id)} style={{ color: '#00d4fc' }} /> : 
                                        <AddCircleIcon onClick={() => addAds(item.id)} style={{ color: '#00d4fc' }} /> 
                                    }
                                </div>
                            </div>
                        )) : 
                        dataPrefs && dataPrefs.ads.length === 0 && ads ?
                        ads.map( (item, index) => (

                            <div key={index} className='publicity_item'>
                                <div className='publicity_item_bottom' style={{ backgroundImage: `url(${item.image_url})` }}/>
                                <span>
                                    {item.name.toUpperCase()}
                                </span>
                                <div className='publicity_item_tags'>
                                    {
                                        item.subgenres.map((sb, index) => (
                                            <p key={index}>{sb}</p>
                                        ))
                                    }
                                </div>
                                <div className='publicity_item_check'>
                                    {
                                        checkPref.includes(item.id.toString()) ?
                                        <CheckCircleIcon  onClick={() => removeAdd(item.id)} style={{ color: '#00d4fc' }}/> : 
                                        <AddCircleIcon onClick={() => addAds(item.id)} style={{ color: '#00d4fc' }}/> 
                                    }
                                </div>
                            </div>
                        )) :
                        <Loader active={true}>Cargando tipos de anuncios...</Loader>
                    }
                    {
                        dataPrefs && dataPrefs.ads.length > 0 && otherPrefs && more === true ?
                        otherPrefs.map( (oth, index) => (
                            <div key={index} className='publicity_item'>
                                <div className='publicity_item_bottom' style={{ backgroundImage: `url(${oth.image_url})` }}/>
                                <span>
                                    {oth.name.toUpperCase()}
                                </span>
                                <div className='publicity_item_tags'>
                                    {
                                        oth.subgenres.map((sb, index) => (
                                            <p key={index}>{sb}</p>
                                        ))
                                    }
                                </div>
                                <div className='publicity_item_check'>
                                    {
                                        checkPref.includes(oth.id) ?
                                        <CheckCircleIcon onClick={() => removeAdd(oth.id)} style={{ color: '#00d4fc' }} /> : 
                                        <AddCircleIcon onClick={() => addAds(oth.id)} style={{ color: '#00d4fc' }}/> 
                                    }
                                </div>
                            </div>
                        )) : null
                    }


                </div>
                <div className='more'>
                    <AddCircleOutlineIcon onClick={() => setMore(!more)}/>
                    <span>{more === true ? 'Ver menos preferencias' : 'Ver más preferencias'}</span>
                </div>
                <div className='save'>
                    <Button onClick={handleOnSubmit}>
                        Guardar preferencias
                    </Button>
                </div>
                

            </div>
            
        </div>
    )
}

// Redux
const mapStateToProps = state => {

    // Extraemos los anuncios
    const ads = state.user.ads;
    const dataPreferences = state.user.result;
    const uid = state.user.uid;

    // Obtenemos los datos de perfil del usuario
    const dataUser = state.user.data;

    let otherPref = [];

    // Hacemos una busqueda para ver los anuncios que no tiene añadidos el usuario
    if(dataPreferences && ads) {
        
        otherPref = ads.filter(ad => {
            let find = dataPreferences.ads.find(dt => dt.id === ad.id )
            
            return !find && ad;
        })
    }
    
    return {
        ads,
        dataPreferences,
        otherPref,
        uid,
        dataUser
    }

}

const mapDispatchToProps = dispatch => {
    return {
        getAllAds: () => dispatch(getAllAds()),
        getDataPreferencesFromUser: () => dispatch(getDataPreferencesFromUser()),
        getDataProfile: () => dispatch(getDataProfile()),
        setNullUid: () => dispatch(setNullUid()),
        signOut: () => dispatch(signOut()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)

